/**
 * Stable CSS class names for E2E — pages/SiteManagement/EditRoles.
 * Containers use `edit-roles__<element>`; inputs and user-interactable controls
 * use `edit-roles-input--<name>`.
 */
export const ER = {
    page: 'edit-roles-page',
    root: 'edit-roles',

    formPaper: 'edit-roles__form-paper',
    formGrid: 'edit-roles__form-grid',

    /* --- Privileges (Banner Görüntüleme) ------------------------------- */
    privilegesBox: 'edit-roles__privileges-box',
    privilegesControl: 'edit-roles__privileges-control',
    inputPrivileges: 'edit-roles-input--privileges',
    privilegeMenuItem: 'edit-roles__privilege-menu-item',
    privilegeMenuItemCheckbox: 'edit-roles-input--privilege-checkbox',
    privilegeMenuItemText: 'edit-roles__privilege-menu-item-text',

    /* --- Role managers section ---------------------------------------- */
    managersBox: 'edit-roles__managers-box',
    managersInner: 'edit-roles__managers-inner',
    managersTitle: 'edit-roles__managers-title',
    managersDescription: 'edit-roles__managers-description',
    inputManagersAutocomplete: 'edit-roles-input--managers-autocomplete',
    inputManagersSearch: 'edit-roles-input--managers-search',
    managersValueChip: 'edit-roles__managers-value-chip',
    managersOption: 'edit-roles__managers-option',
    managersOptionPrimary: 'edit-roles__managers-option-primary',
    managersOptionSecondary: 'edit-roles__managers-option-secondary',

    managersSelectedBox: 'edit-roles__managers-selected-box',
    managersSelectedSummary: 'edit-roles__managers-selected-summary',
    managersSelectedChipsBox: 'edit-roles__managers-selected-chips-box',
    managersSelectedChip: 'edit-roles__managers-selected-chip',

    /* --- Actions ------------------------------------------------------- */
    actionsBox: 'edit-roles__actions-box',
    btnSave: 'edit-roles-input--button-save',
} as const;

export const erCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
